import { useState } from "react";
import { useTranslation } from "react-i18next";
import { faqItems, testimonials } from "@/mocks/home";

export default function FAQSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            {t("section_faq")}
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            {t("section_faq_desc")}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10">
          <div>
            <div className="space-y-3">
              {faqItems.map((item, index) => (
                <div
                  key={index}
                  className="bg-background-50 rounded-lg overflow-hidden"
                >
                  <button
                    className="w-full flex items-center justify-between px-5 py-4 text-left"
                    onClick={() => setOpenIndex(openIndex === index ? null : index)}
                    aria-expanded={openIndex === index}
                  >
                    <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                      {item.question}
                    </span>
                    <span className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-300 text-foreground-400 ${
                      openIndex === index ? "rotate-180" : ""
                    }`}>
                      <i className="ri-arrow-down-s-line"></i>
                    </span>
                  </button>
                  <div
                    className={`transition-all duration-300 overflow-hidden ${
                      openIndex === index ? "max-h-96 pb-5 px-5" : "max-h-0"
                    }`}
                  >
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-xl font-heading text-foreground-900 mb-6 text-center lg:text-left">
              {t("section_testimonials")}
            </h3>
            <div className="space-y-4">
              {testimonials.map((tItem) => (
                <div key={tItem.id} className="bg-background-50 rounded-lg p-5">
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    {tItem.content}
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-full bg-accent-200 flex items-center justify-center text-accent-700 font-medium text-sm">
                      {tItem.name.charAt(0)}
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">{tItem.name}</p>
                      <p className="text-xs text-foreground-400">{tItem.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}